import Box from '@zenbusiness/zui/Box';
import List from '@zenbusiness/zui/List';
import ListItem from '@zenbusiness/zui/ListItem';
import { superstyled } from '@zenbusiness/zui/styles';

export const BenefitList = superstyled({
  tag: List,
  name: 'WhatsIncluded',
  slot: 'BenefitList',
  styles: ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(4),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.fixed.white,
    borderRadius: theme.shape.rounded.xl,

    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
      padding: theme.spacing(3),
    },
  }),
});

export const BenefitItem = superstyled({
  tag: ListItem,
  name: 'WhatsIncluded',
  slot: 'BenefitItem',
  styles: ({ theme }) => ({
    alignItems: 'flex-start',
    padding: theme.spacing(0),
  }),
});

export const Icon = superstyled({
  tag: Box,
  name: 'WhatsIncluded',
  slot: 'Icon',
  styles: () => ({
    width: '2.5rem',
    height: '2.5rem',
  }),
});
